import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { Circles } from '../../common/loadingComponent';
import { searchActions } from '../../../store/searchStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import Paging from '../../common/pagingComponent';
import Section from '../../common/section';
import BbCheckbox from '../../styling/bbCheckbox';
import NoDataComponent from '../../common/noDataComponent';

import '../../../css/search/search.scss'

class BankruptcySearchResult extends React.Component {
    render() {
        const data = isNullOrUndefined(this.props.search.searchResult) ? null : this.props.search.searchResult.data;
        const isSearching = isNullOrUndefined(this.props.search) ? false : this.props.search.isSearching;

        if (isSearching)
            return <Circles />

        if (isNullOrUndefined(data) || isNullOrUndefined(data.items) || data.items.length === 0)
            return <NoDataComponent />

        const found = data.found || 0;
        const page = this.props.search.searchParams.page;
        const pageSize = this.props.search.searchPaging.count;


        return (
            <>
                <div className='card card-special' style={{ fontSize: "0.875em" }}>
                    <div className="card-body">
                        {data.items.map((item) => <Section key={item.rowNum} level={2}
                            name={this.getName(item)}
                            headerBody={<>
                                <div className="name" style={{ flex: "1 0" }}>{this.getName(item)}</div>
                                <div className="bb-chk-pdf-export" style={{ flex: "0 1 auto" }} onClick={(e) => e.stopPropagation()}>
                                    <BbCheckbox name={`pdf-id-${item.rowNum}`} label={this.props.translate("Common.AddToReport")} id={`pdf-id-${item.rowNum}`}
                                        value={this.props.search.exportSettings.ids.includes(item.id)}
                                        onChange={(v) => v ? this.props.addToPdfExport(item.id) : this.props.removeFromPdfExport(item.id)} />
                                </div>
                            </>}
                        >
                            <div className="p-3">
                                <table className="table table-report-section key-value" style={{ fontSize: "0.875em " }}>
                                    <colgroup>
                                        <col width="20%" />
                                        <col width="80%" />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <td><Translate id="Search.Bankruptcies.Result.BusinessName" /></td>
                                            <td>{item.businessName}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Search.Bankruptcies.Result.FileId" /></td>
                                            <td>{item.fileId}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Search.Bankruptcies.Result.FullAddress" /></td>
                                            <td>{item.fullAddress}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Search.Bankruptcies.Result.LegalForm" /></td>
                                            <td>{item.legalForm}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Search.Bankruptcies.Result.DecisionDate" /></td>
                                            <td>{item.dateFormated}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Search.Bankruptcies.Result.CompanyId" /></td>
                                            <td>{item.ico}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Search.Bankruptcies.Result.BirthDate" /></td>
                                            <td>{item.birthDateFormated}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Search.Bankruptcies.Result.ControllerName" /></td>
                                            <td>{item.controllerName}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Search.Bankruptcies.Result.ControllerAddress" /></td>
                                            <td>{item.controllerAddress}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Search.Bankruptcies.Result.Note" /></td>
                                            <td>{ReactHtmlParser(item.note)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Section>)}
                    </div>
                </div>
                {this.renderPaging(found, page, pageSize)}
            </>
        )
    }

    componentDidMount() {
        this.props.resetPdfExport();
    }

    componentDidMount() {
        const data = this.getSearchParams();
        if (!isNullOrUndefined(data))
            this.props.getBankruptcies(data);
    }

    componentDidUpdate(prevProps, _prevState) {
        const paging = this.props.search.searchPaging;
        if (prevProps.search.searchPaging.page !== paging.page || this.props.search.languageChanged) {
            const data = { ...this.getSearchParams(), page: paging.page, pageSize: paging.count }
            this.props.getBankruptcies(data);
        }
    }

    componentWillUnmount() {
        this.props.endBankruptciesSearch();
    }

    getName = (item) => `${item.datePublishedFormated} ${isNullOrUndefined(item.insolvencyCode) ? "" : item.insolvencyCode}`;

    getSearchParams() {
        const historyData = !isNullOrUndefined(this.props.history) && !isNullOrUndefined(this.props.history.location) ? this.props.history.location.state : undefined;
        return isNullOrUndefined(this.props.location.state) ? historyData : this.props.location.state;
    }

    renderPaging = (totalCount, page, pageSize) => {
        return (page && Math.ceil(totalCount / pageSize) > 1) ? (
            <div className="paging-wrapper">
                <Paging selectedPage={page}
                    totalPages={Math.ceil(totalCount / pageSize)}
                    setPage={p => {
                        this.props.changePageBankruptcy(p);
                    }} />
            </div>
        ) : null;
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state, search: state.search }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(BankruptcySearchResult)));
